<template>
  <footer>
    <div class="row">
      <div class="col-sm-4 text-left">
        <a
          v-if="isPrivacyUrlSet"
          id="footerImprint"
          class="footer-links copyright"
          target="_blank"
          :href="privacy_url"
        >
          {{ $t('footer.imprint') }}
        </a>
        <a
          v-if="isDataProtectionUrlSet"
          id="footerPrivacy"
          class="footer-links side-margin copyright"
          target="_blank"
          :href="data_protection_url"
        >
          {{ $t('footer.privacy') }}
        </a>
      </div>
      <div class="col-sm-4">
        <h5 class="copyright">
          {{ $t('footer.copyright') }}
        </h5>
      </div>
      <div class="col-sm-4 text-align-right">
        <h5 class="version">
          {{ portalVersion() }}
        </h5>
      </div>
    </div>
    <cookie-law
      v-if="cookie_law_enabled"
      theme="dark-lime"
      button-class="btn btn-primary"
      :button-text="$t('footer.cookie_law.button_text')"
      :message="$t('footer.cookie_law.message')"
    />
  </footer>
</template>

<script>
import json from '@/configuration.json'
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'Footer',
  components: {CookieLaw},
  data() {
    return {
      cookie_law_enabled: json.cookie_law,
      data_protection_url: json.gdpr_urls.data_protection_url,
      privacy_url: json.gdpr_urls.privacy_url

    }
  },
  computed: {
    isDataProtectionUrlSet(){
      return !!(json.gdpr_urls && json.gdpr_urls.data_protection_url)
    },
    isPrivacyUrlSet(){
      return !!(json.gdpr_urls && json.gdpr_urls.privacy_url)
    }
  },
  methods: {
    portalVersion() {
      return 'v. ' + json.passenger_portal_version
    }
  }
}
</script>
